var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilePdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 30,
    height: 30,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_24537",
    x: -11.629,
    y: -7.889,
    width: 39.057,
    height: 39.069,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6b6b6b",
    floodOpacity: 0.271
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_83",
    "data-name": "Mask Group 83",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(3.371 1.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24536",
    "data-name": "Path 24536",
    d: "M19.859,0H8.786L0,8.966v15.57A3.067,3.067,0,0,0,3.067,27.6H19.859a3.067,3.067,0,0,0,3.067-3.067V3.067A3.067,3.067,0,0,0,19.859,0Z",
    transform: "translate(0.047 0.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.37, -1.11)",
    filter: "url(#Path_24537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24537-2",
    "data-name": "Path 24537",
    d: "M7167.35,2062.879l-8.863,9.068s1.911,0,3.9,0c1.72,0,3.689.018,4.451-1.152.737-1.132.688-2.749.7-4.324A31.429,31.429,0,0,0,7167.35,2062.879Z",
    transform: "translate(-7155.12 -2061.77)",
    fill: "#f1f1f1"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilePdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-pdf.6ebcbbe0.svg";
export { ForwardRef as ReactComponent };